import { Accordion as FuseAccordion, AccordionProps as FuseAccordionProps } from "@tvg/fuse-design/accordion";
import React from "react";
import styled from "styled-components";

export interface AccordionProps extends Omit<Partial<FuseAccordionProps>, "children"> {
  children: string;
}

const StyledFuseAccordion = styled(FuseAccordion)`
  h2 {
    color: var(--color-font-heading);
    font-weight: var(--font-weight-heading);
    font-size: var(--font-size-2);
    line-height: var(--font-line-height-2);
    font-family: var(--font-brand), Arial, Helvetica, sans-serif;
  }
  p {
    color: var(--color-font-paragraph);
    font-weight: var(--font-weight-paragraph);
    font-size: var(--font-size-1);
    line-height: var(--font-line-height-1);
    margin: var(--spacing-paragraph-margin-bottom-1) 0;
    font-family: var(--font-brand), Arial, Helvetica, sans-serif;
  }
`;

const Accordion: React.FC<AccordionProps> = ({ children, ...props }: AccordionProps) => {
  return (
    <StyledFuseAccordion
      chevronInline
      dataTestId="fuse-accordion-seo-accordion"
      headingTag="h1"
      hideBorder
      componentId="seo-accordion"
      titleSize={{ l: "large", m: "medium", s: "small", xl: "xlarge", xs: "xsmall", xxl: "xlarge", xxs: "xxsmall" }}
      {...props}
    >
      <span dangerouslySetInnerHTML={{ __html: children }} key="markupTorso" />
    </StyledFuseAccordion>
  );
};

export default React.memo(Accordion);
